var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.42 0.189318C8.60571 -0.398008 6.63338 0.418949 5.76574 2.1172L4.72266 4.15884C4.59872 4.40143 4.40143 4.59872 4.15884 4.72266L2.1172 5.76574C0.418949 6.63338 -0.398008 8.60571 0.189318 10.42L0.895415 12.6013C0.979311 12.8604 0.979311 13.1395 0.895415 13.3987L0.189318 15.5799C-0.398008 17.3943 0.418949 19.3666 2.1172 20.2343L4.15884 21.2772C4.40143 21.4012 4.59872 21.5985 4.72266 21.8411L5.76574 23.8828C6.63338 25.581 8.60571 26.398 10.42 25.8107L12.6013 25.1045C12.8604 25.0207 13.1395 25.0207 13.3987 25.1045L15.5799 25.8107C17.3943 26.398 19.3666 25.581 20.2343 23.8828L21.2772 21.8411C21.4012 21.5985 21.5985 21.4012 21.8411 21.2772L23.8828 20.2343C25.581 19.3666 26.398 17.3943 25.8107 15.5799L25.1045 13.3987C25.0207 13.1395 25.0207 12.8604 25.1045 12.6013L25.8107 10.42C26.398 8.60571 25.581 6.63338 23.8828 5.76574L21.8411 4.72266C21.5985 4.59872 21.4012 4.40143 21.2772 4.15884L20.2343 2.1172C19.3666 0.418949 17.3943 -0.398008 15.5799 0.189318L13.3987 0.895415C13.1395 0.979298 12.8604 0.979311 12.6013 0.895415L10.42 0.189318ZM6.2165 12.6858L8.0472 10.855L11.7086 14.5165L19.0314 7.19369L20.8621 9.02438L11.7086 18.1778L6.2165 12.6858Z",
    fill: "#09CB11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.2572aab942d4468a1dcb9c688dd1adde.svg";
export { ForwardRef as ReactComponent };